import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcTopology = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M13.835 6.698a2.497 2.497 0 0 1-1.302.745l1.633 2.858a2.498 2.498 0 0 1 1.303-.745l-1.634-2.858Zm4 7a2.498 2.498 0 0 1-1.302.745l1.634 2.858a2.497 2.497 0 0 1 1.302-.745l-1.634-2.858Zm-6.366-6.255c-.51-.11-.96-.376-1.302-.745L8.533 9.556c.51.11.96.376 1.302.745l1.634-2.858Zm-1.634 6.255a2.498 2.498 0 0 1-1.302.745l1.634 2.858a2.497 2.497 0 0 1 1.302-.744l-1.634-2.859Zm-2.366.745c-.51-.11-.96-.376-1.302-.745l-1.634 2.858c.51.11.96.376 1.302.745l1.634-2.858Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M12 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm8 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-6-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM4 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm14-9a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM8 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcTopology");

export { IcTopology };
//# sourceMappingURL=ic-topology.js.map
